/**
 * 模块说明：业务仓管理
 */
import { Service } from '@/tools'
export class BizWarehouseService<T extends TStock.BizWarehouse> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TStock.BizWarehouse}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 功能：查询业务仓列表
   * /api/stock/bizWarehouse/v1/list
   */
  list = <K extends T['ApiList']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiList', data)
  /**
   * 模块说明：查询业务仓列表
   */
  businessList = this.list

  /**
   * 功能：更新业务仓
   */
  update = (data: T['ApiUpdate']['req']): Promise<T['ApiUpdate']['res']> => this.post2('v1/ApiUpdate', data)
  /**
   * 模块说明：更新业务仓
   */
  businessUpdate = this.update

  /**
   * 功能：暂停业务仓
   */
  updateStatus = (data: T['ApiUpdateStatus']['req']): Promise<T['ApiUpdateStatus']['res']> => this.post2('v1/ApiUpdateStatus', data)
  /**
   * 模块说明：启用-停用暂停业务仓
   */
  businessUpdateStatus = this.updateStatus

  /**
   * 功能：分页查询业务仓列表
   */
  page = (data: T['ApiPage']['req']): Promise<T['ApiPage']['res']> => this.post2('v1/ApiPage', data)
  /**
   * 模块说明：列表相关接口
   */
  businessPage = this.page

  /**
   * 功能：查询部门下业务组信息列表
   */
  getPurchaseGroupList = (data: T['ApiGetPurchaseGroupList']['req']): Promise<T['ApiGetPurchaseGroupList']['res']> => this.post2('v1/ApiGetPurchaseGroupList', data)
  /**
   * 模块说明：查询部门下业务组信息列表
   */
  GetPurchaseGroupList = this.getPurchaseGroupList

  /**
   * 功能：获取公司/小连锁下部门信息列表
   */
  getDeptInfoList = (data: T['ApiGetDeptInfoList']['req']): Promise<T['ApiGetDeptInfoList']['res']> => this.post2('v1/ApiGetDeptInfoList', data)
  /**
   * 模块说明：部门列表
   */
  businessGetDeptInfoList = this.getDeptInfoList

  /**
   * 功能：查询用户所属公司
   */
  getCompanyInfo = (data?: T['ApiGetCompanyInfo']['req']): Promise<T['ApiGetCompanyInfo']['res']> => this.post2('v1/ApiGetCompanyInfo', data)

  /**
   * 功能：通过实体仓id查询业务仓列表
   */
  getByWarehouseIds = (data: T['ApiGetByWarehouseIds']['req']): Promise<T['ApiGetByWarehouseIds']['res']> => this.post2('v1/ApiGetByWarehouseIds', data)
            
  /**
   * 功能：查看业务仓详情
   */
  detail = (data: T['ApiDetail']['req']): Promise<T['ApiDetail']['res']> => this.post2('v1/ApiDetail', data)
  /**
   * 模块说明：查看业务仓详情
   */
  businessDetails = this.detail

  /**
   * 功能：删除业务仓
   */
  deleteById = (data: T['ApiDeleteById']['req']): Promise<T['ApiDeleteById']['res']> => this.post2('v1/ApiDeleteById', data)
            
  /**
   * 功能：添加业务仓
   */
  add = (data: T['ApiAdd']['req']): Promise<T['ApiAdd']['res']> => this.post2('v1/ApiAdd', data)
  /**
   * 模块说明：添加业务仓
   */
  businessAdd = this.add
}
